@if (showMarketHelp) {
    <ms-market-help [optionGroup]="optionGroup" [eventHelpText]="eventHelpText"></ms-market-help>
}
<div class="option-group-container six-pack-container" [ngClass]="tupleClass">
    <div class="option-group-header">
        <span class="six-pack-team"></span>
        @if (showSixPackParticipantImages) {
            <div class="options-header-container" *msShowInEpcot="{ showInEpcot: true }">
                <ng-container [ngTemplateOutlet]="optionsHeaderTemplate"></ng-container>
            </div>
            <ng-container *msShowInEpcot="{ showInEpcot: false }" [ngTemplateOutlet]="optionsHeaderTemplate"></ng-container>
        } @else {
            <ng-container [ngTemplateOutlet]="optionsHeaderTemplate"></ng-container>
        }
    </div>

    @for (optionRow of optionRows; track trackByPlayer(i, optionRow); let i = $index) {
        @if (showSixPackParticipantImages) {
            <ng-container
                *msShowInEpcot="{ showInEpcot: true }"
                [ngTemplateOutlet]="optionRowTemplateWithImages"
                [ngTemplateOutletContext]="{ optionRow: optionRow, index: i }"></ng-container>

            <ng-container
                *msShowInEpcot="{ showInEpcot: false }"
                [ngTemplateOutlet]="optionRowTemplateWithoutImages"
                [ngTemplateOutletContext]="{ optionRow: optionRow, index: i }"></ng-container>
        } @else {
            <ng-container
                [ngTemplateOutlet]="optionRowTemplateWithoutImages"
                [ngTemplateOutletContext]="{ optionRow: optionRow, index: i }"></ng-container>
        }
    }

    @if (hasInsights) {
        <ng-container *msComponentProxy="bettingInsightsComponent"></ng-container>
    }
</div>

<ng-template #optionsHeaderTemplate>
    @for (header of optionHeaders | keyvalue: keepOrder; track $index) {
        <span class="six-pack-col">{{ header.value }}</span>
    }
</ng-template>

<ng-template #optionRowTemplateWithoutImages let-optionRow="optionRow" let-index="index">
    <div class="attribute-key" [class.option-name-stats-container]="showPlayerStats">
        <div class="six-pack-player-name">
            <span>{{ optionRow.player }}</span>
            @if (isMarketPromoted(index)) {
                <ms-promotion-badge class="no-title"></ms-promotion-badge>
            }
        </div>
        @if (showPlayerStats) {
            <ng-container *ngTemplateOutlet="playerStatsTemplate; context: { $implicit: optionRow }"></ng-container>
        }
    </div>

    @for (column of optionRow.columns | keyvalue: keepOrder; track trackByCol($index, column)) {
        @if (!column.value) {
            <div class="option">
                <span class="empty-option">-</span>
            </div>
        } @else {
            <ms-option
                [tracking]="{ source: tracking, moduleType: trackingModuleType }"
                [option]="column.value"
                [optionGroup]="optionGroup"
                [event]="event"
                [showPromoBadge]="!!crmPromoIdsMap[column.value.id]"
                [sourceOfPick]="sourceOfPick"
                [betDetails]="betDetails"></ms-option>
        }
    }
</ng-template>

<ng-template #optionRowTemplateWithImages let-optionRow="optionRow" let-index="index">
    <div class="option-row">
        <div class="attribute-key" [class.option-name-stats-container]="showPlayerStats">
            @if (showParticipantImages) {
                <ms-participant-image
                    class="participant-logo"
                    [participantImage]="optionRow.playerImage"
                    [sportId]="event.sport.id"
                    [showFallback]="false"
                    [showLogoColor]="showLogoColor"
                    (logoLoaded)="imageLoaded($event, index)"></ms-participant-image>
            }

            <div class="six-pack-player-name">
                <span>{{ optionRow.player }}</span>
                @if (isMarketPromoted(index)) {
                    <ms-promotion-badge class="no-title"></ms-promotion-badge>
                }
            </div>
            @if (showPlayerStats) {
                <ng-container *ngTemplateOutlet="playerStatsTemplate; context: { $implicit: optionRow }"></ng-container>
            }
        </div>

        <div class="options-container">
            @for (column of optionRow.columns | keyvalue: keepOrder; track trackByCol($index, column)) {
                @if (!column.value) {
                    <div class="option">
                        <span class="empty-option">-</span>
                    </div>
                } @else {
                    <ms-option
                        [tracking]="{ source: tracking, moduleType: trackingModuleType }"
                        [option]="column.value"
                        [optionGroup]="optionGroup"
                        [event]="event"
                        [showPromoBadge]="!!crmPromoIdsMap[column.value.id]"
                        [sourceOfPick]="sourceOfPick"
                        [betDetails]="betDetails"></ms-option>
                }
            }
        </div>
    </div>
</ng-template>

<ng-template #playerStatsTemplate let-optionRow>
    <ms-player-stats
        [playerStats]="event.playerStats"
        [sportId]="event.sport.id"
        [playerStatsProps]="optionGroup.detailedGrouping.playerStatsProps"
        [playerIds]="[optionRow.playerId]"
        [source]="optionGroup.source"></ms-player-stats>
</ng-template>
